<nz-row nzJustify="start" nzAlign="middle" style="margin-bottom: 16px;">

  <nz-col style="display: flex; align-items: center; gap: 12px;">
    <label style="font-weight: 500;">Is Compliance & Safety needed?</label>

    <button nz-button [nzType]="enablePermissions ? 'primary' : 'default'" (click)="onToggleSafety(true)"
      nzShape="round" style="display: flex; align-items: center; gap: 4px;">
      <i nz-icon nzType="check"></i> Yes
    </button>

    <button nz-button [nzType]="!enablePermissions ? 'primary' : 'default'" (click)="onToggleSafety(false)"
      nzShape="round" style="display: flex; align-items: center; gap: 4px;">
      <i nz-icon nzType="close"></i> No
    </button>
  </nz-col>

</nz-row>

<div *ngIf="enablePermissions">
  <nz-row nzJustify="space-between" nzAlign="middle" style="margin-bottom: 12px;">

   <nz-col>
    <nz-select
      nzShowSearch
      nzAllowClear
      nzPlaceHolder="Search..."
      [(ngModel)]="searchValue"
      (ngModelChange)="onSearch()"
      (nzOnClear)="onClearSearch()"
      style="width: 280px;"
    >
      <nz-option *ngFor="let item of lienceList" [nzValue]="item.id" [nzLabel]="item.name"></nz-option>
    </nz-select>
  </nz-col>
    <nz-col>
      <button nz-button nzType="primary" (click)="onAdd()">Add</button>
    </nz-col>
  </nz-row>

  <nz-spin [nzSpinning]="loading" [nzTip]="'Loading data...'">

    <div class="table-container">
      <div class="table-wrapper">
        <nz-table [nzData]="complianceList" [nzBordered]="true" [nzSize]="'middle'" [nzShowPagination]="false"
          [nzScroll]="{ x: '1500px' }">
          <thead>
            <tr>
              <th nzWidth="20%">Compliance Name</th>
              <th nzWidth="15%">Currency Amount</th>
              <th nzWidth="15%">Exchange Rate</th>
              <th nzWidth="15%">Amount (USD)</th>
              <th nzWidth="15%">Currency Type</th>
              <th nzWidth="15%">Created By</th>
              <th nzWidth="15%">Created At</th>
              <th nzWidth="15%">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of complianceList">
              <!-- <td>{{ p.compliance_safety_name }}</td> -->
              <td>{{ p.license_name }}</td>
              <td>{{ p.currency_amount }}</td>
              <td>{{ p.exchange_rate }}</td>
              <td>{{ p.amount_usd }}</td>
              <td>{{ p.currency_details?.name }}</td>
               <td>
                <span class="user-avatar">{{ p.created_by_name ? p.created_by_name[0].toUpperCase() : '?' }}</span>
                <span> {{ p.created_by_name }}</span>
              </td>
              <td>{{ p.created_at | date: 'MMM d, y, h:mm a' }}</td>
              <td>
                <button nz-button (click)="onEdit(p)" [nzSize]="'small'" class="action-button">
                  <i nz-icon nzType="edit"></i>
                </button>
                <button
                  nz-button
                  nzDanger
                  [nzSize]="'small'"
                  class="action-button"
                  style="margin-left: 10px;"
                  [nz-popconfirm]="deletePermissionPopconfirm"
                  [nzPopconfirmTitle]="''"
                  [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
                  nzPopconfirmPlacement="bottom"
                  (nzOnConfirm)="deletePermission(p)"
                >
                  <i nz-icon nzType="delete"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>

    </div>


  </nz-spin>


</div>

<nz-modal [(nzVisible)]="isVisibleModal" [nzTitle]="isEditing ? 'Edit Compliance' : 'Add Compliance'"
  (nzOnCancel)="handleModalCancel()">
  <ng-container *nzModalContent>
    <form [formGroup]="eventForm" nz-form nzLayout="vertical">

      <nz-form-item>
        <nz-form-label nzRequired nzFor="compliance_safety">Compliance Safety</nz-form-label>
        <nz-form-control>
          <nz-select nzShowSearch nzAllowClear formControlName="compliance_safety" id="compliance_safety" nzPlaceHolder="License Type">
            <nz-option *ngFor="let item of lienceList" [nzValue]="item.id" [nzLabel]="item.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="currency">Currency</nz-form-label>
        <nz-form-control>
          <nz-select nzShowSearch nzAllowClear formControlName="budget_currency_type" id="currency" nzPlaceHolder="Select currency"
            (ngModelChange)="onCurrencyChange($event)">
            <nz-option *ngFor="let currency of currencies" [nzValue]="currency.id" [nzLabel]="currency.symbol">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="budget_currency_amount">Amount</nz-form-label>
        <nz-form-control>
          <input nz-input type="number" id="budget_currency_amount" formControlName="budget_currency_amount"
            (ngModelChange)="calculateAmount($event)" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="usd_currency_exchange_rate">Exchange Rate</nz-form-label>
        <nz-form-control>
          <nz-input-group [nzAddOnAfter]="addOnAfterTemplate">
            <input nz-input type="number" formControlName="usd_currency_exchange_rate"
              id="usd_currency_exchange_rate" />
          </nz-input-group>
          <ng-template #addOnAfterTemplate>
            <button nz-button nzType="text" (click)="fetchConvertion($event)">
              <nz-icon nzType="reload" [nzSpin]="loadingConversion" />
            </button>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="budget_amount">Amount (USD)</nz-form-label>
        <nz-form-control>
          <input nz-input type="number" formControlName="budget_amount" id="budget_amount" [disabled]="true" />
        </nz-form-control>
      </nz-form-item>

    </form>
  </ng-container>


  <div *nzModalFooter style="text-align: right;">
    <button nz-button (click)="handleModalCancel()">Cancel</button>
    <button nz-button nzType="primary" [disabled]="eventForm.invalid" (click)="onSubmit()">
      {{ isEditing ? 'Update' : 'Add' }}
    </button>
  </div>
</nz-modal>
<ng-template #deletePermissionPopconfirm>
  <div class="custom-popconfirm-header">
    <span class="custom-popconfirm-title">Confirm Deletion</span>
  </div>
  <div class="custom-popconfirm-icon-area">
    <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
      <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
    </span>
  </div>
  <div class="custom-popconfirm-message description">
    Are you sure you want to delete this compliance permission?<br />
    <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
  </div>
  <!-- <div class="custom-popconfirm-actions" style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px;">
    <button nz-button nzType="default" nzSize="small" (click)="$event.stopPropagation(); deletePermissionPopconfirm.cancel()">Cancel</button>
    <button nz-button nzType="primary" nzDanger nzSize="small" (click)="$event.stopPropagation(); deletePermissionPopconfirm.confirm()">OK</button>
  </div> -->
</ng-template>
